import styled from 'styled-components';

export const OccurencesFieldsContainer = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
